

export const frontMatter = {};
export const contentTitle = undefined;



import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    li: "li",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_components.ul, {
    children: ["\n", _jsx(_components.li, {
      children: "Dobry denj! Restoran jest otvorjeny?"
    }), "\n", _jsx(_components.li, {
      children: "Dobry denj. Da, my jest otvorjeny."
    }), "\n", _jsx(_components.li, {
      children: "Možno tu piti něčto?"
    }), "\n", _jsx(_components.li, {
      children: "Očevidno, čto prinesti k vas?"
    }), "\n", _jsx(_components.li, {
      children: "Čto vy imat?"
    }), "\n", _jsx(_components.li, {
      children: "Čaj, kava, pivo, vino, vodka..."
    }), "\n", _jsx(_components.li, {
      children: "A vy takože imat něčto hladne?"
    }), "\n", _jsx(_components.li, {
      children: "Da, my imat sok, voda, mlěko..."
    }), "\n", _jsx(_components.li, {
      children: "Togda dajte nam dva soki, prosim."
    }), "\n", _jsx(_components.li, {
      children: "Dva soki, dobro. Vy takože hočet jesti něčto?"
    }), "\n", _jsx(_components.li, {
      children: "Može... Vy imat hlěb?"
    }), "\n", _jsx(_components.li, {
      children: "Da, očevidno. Hlěb, meso, ryba, vsečto jest."
    }), "\n", _jsx(_components.li, {
      children: "Hvala, samo hlěb s maslo, prosim."
    }), "\n"]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

